import { render } from "./LineAwesome.vue?vue&type=template&id=28d56730"
import script from "./LineAwesome.vue?vue&type=script&lang=ts"
export * from "./LineAwesome.vue?vue&type=script&lang=ts"
script.render = render

export default script